import ModalBox from "components/Modal";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

interface BlockModal {
    blocker: any;
}

const BlockModal = ({ blocker }: BlockModal) => {
    const [t] = useTranslation();
    const [blockModal, setBlockModal] = useState<boolean>(false);

    useEffect(() => {
        blocker.state === "blocked" && setBlockModal(true);
    }, [blocker]);

    const handleBlockerProceed = () => {
        blocker.proceed?.();
        blocker.reset?.();
    };
    return (
        <>
            {blocker.state === "blocked" ? (
                <ModalBox
                    onClose={() => setBlockModal(false)}
                    open={blockModal}
                    mainTitle={t("BPSettings.ModalBlockTitle")}
                >
                    <div className="block-modal-body">
                        <span>{t("BPSettings.ModalBlockText1")}</span>
                        <span>{t("BPSettings.ModalBlockText2")}</span>
                        <div className="block-modal-actions">
                            <button onClick={handleBlockerProceed}>{t("BPSettings.Leave")}</button>
                            <button onClick={() => setBlockModal(false)}>{t("Accounting.StayOnPage")}</button>
                        </div>
                    </div>
                </ModalBox>
            ) : (
                ""
            )}
        </>
    );
};

export default BlockModal;
